/* eslint-disable no-underscore-dangle */
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Grid, Fade, Typography } from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import AddIcon from '@material-ui/icons/Add';
import Img from 'react-cool-img';
import { ORDERCONFIG } from '../../config/showroomConfig';
import LeftBar from './LeftBar';
import LeftBarPrintDetail from './LeftBarPrintDetail';
import api from '../../services/api';
import style from './styles';
import ModalProduct from '../ModalProduct';
import { events } from '../../consts';
import { useEventDispatcher } from '../../hooks';
import useConfigContext from '../../hooks/useConfigContext';

import useViewAsContext from '../../hooks/useViewAsContext';

const styles = theme => style(theme);
const screenWidth = window.innerWidth;

const dictIdDelivery = {
  1: '5f34a6b5ed5ff21fbc9939c6',
  2: '5f34a7b6bc82e351349c76bf',
  3: '5f34a7c2bc82e351349c76c0',
};
// const dictIdDeliveryTitle = {
//   1: 'SHIPS FEBRUARY 15-30',
//   2: 'SHIPS MARCH 15-30',
//   3: 'SHIPS APRIL 15-30',
// };

function PrintView({ classes, isSwimwear }) {
  const { configState } = useConfigContext();
  const seasonName = configState.season.name || '';
  const { params } = useRouteMatch();
  const { delivery_id } = params;
  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);

  const [selectedPrint, setSelectedPrint] = useState(null);
  const [selectedColor, setSelectedColor] = useState({ value: 'none' });
  const [gridSize, setGridSize] = useState('Large');
  const [prints, setPrints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [colorOptions, setColorOptions] = useState([]);

  const { viewAsState } = useViewAsContext();
  const { selectedUser } = viewAsState;

  const dispatchEvent = useEventDispatcher();
  const handlePrevProduct = useCallback(() => {
    const selectedProductIndex = products.findIndex(
      p => p.style_code === selectedProduct.style_code
    );
    if (selectedProductIndex === 0) {
      // vou pro ultimo item
      const product = products.find(
        (p, index) => index === products.length - 1
      );
      setSelectedProduct(product);
    } else {
      // volto um item
      const product = products.find(
        (p, index) => index === selectedProductIndex - 1
      );

      setSelectedProduct(product);
    }
  }, [products, selectedProduct]);

  const handleNextProduct = useCallback(() => {
    const selectedProductIndex = products.findIndex(
      p => p.style_code === selectedProduct.style_code
    );
    if (selectedProductIndex >= products.length - 1) {
      setSelectedProduct(products[0]);
    } else {
      const product = products.find(
        (p, index) => index === selectedProductIndex + 1
      );
      setSelectedProduct(product);
    }
  }, [products, selectedProduct]);

  const handlePrevPrint = useCallback(() => {
    const selectedPrintIndex = prints.findIndex(
      p => p.name === selectedPrint.name
    );
    // se sou o primeiro item
    if (selectedPrintIndex === 0) {
      // vou pro ultimo item
      setSelectedPrint(prints[prints.length - 1]);
    } else {
      // volto um item
      const print = prints.find((p, index) => index === selectedPrintIndex - 1);

      setSelectedPrint(print);
    }
  }, [prints, selectedPrint]);

  const handleNextPrint = useCallback(() => {
    const selectedPrintIndex = prints.findIndex(
      p => p.name === selectedPrint.name
    );
    if (selectedPrintIndex >= prints.length - 1) {
      setSelectedPrint(prints[0]);
    } else {
      const print = prints.find((p, index) => index === selectedPrintIndex + 1);
      setSelectedPrint(print);
    }
  }, [prints, selectedPrint]);

  useEffect(() => {
    setSelectedPrint(null);
  }, [delivery_id]);

  const handleAddFavorite = useCallback(
    async product => {
      try {
        setProducts(
          products.map(produto => {
            if (produto.style_code === product.style_code) {
              dispatchEvent(events.addToCollection, {
                click: !produto.isFavorite,
                location: 'Prints',
              });
              return { ...produto, isFavorite: !produto.isFavorite };
            }

            return produto;
          })
        );
        await api.post(`/collections`, {
          style_code: product.style_code,
          user_id: selectedUser._id || null,
        });
      } catch (err) {
        setProducts(
          products.map(produto => {
            if (produto.style_code === product.style_code) {
              return { ...produto, isFavorite: produto.isFavorite };
            }

            return produto;
          })
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [products]
  );

  const handleClickOpen = product => {
    setOpen(true);
    setSelectedProduct(product);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProduct(null);
  };

  const gridSizeValues = useMemo(() => {
    if (gridSize === 'Small') {
      return {
        height: 'auto',
        width:
          window.innerWidth > 1400
            ? window.innerWidth / 12
            : window.innerWidth / 9,
        fontSize: 10,
      };
    }
    if (gridSize === 'Large') {
      return {
        height: 'auto',
        width:
          window.innerWidth > 1400
            ? window.innerWidth / 4
            : window.innerWidth / 3.5,
        fontSize: 16,
      };
    }

    return {
      height: 'auto',
      width: window.innerWidth / 7,
      fontSize: 14,
    };
  }, [gridSize]);

  useEffect(() => {
    async function loadPrints() {
      try {
        setLoading(true);
        const response = await api.get(
          `/prints/${dictIdDelivery[delivery_id]}`,
          {
            params: {
              color:
                selectedColor.value !== 'none' ? selectedColor.value : null,
            },
          }
        );

        const orderedList = ORDERCONFIG.PRINT[
          isSwimwear
            ? 'ORDENACAO_POR_DELIVERY_PREFALL'
            : 'ORDENACAO_POR_DELIVERY'
        ][delivery_id].map(ordem => {
          const print = response.data.find(p => p.name === ordem.name);
          if (!print) {
            return null;
          }

          return {
            ...print,
            formattedName: `${String(ordem.ordem).padStart(2, '0')} ${
              print.name
            }`,
          };
        });
        setPrints(orderedList.filter(i => !!i));

        // setPrints(
        //   response.data.map((print, index) => ({
        //     ...print,
        //     formattedName: `${String(index + 1).padStart(2, '0')} ${
        //       print.name
        //     }`,
        //   }))
        // );
      } catch (err) {
        console.log(err); //eslint-disable-line
      } finally {
        setLoading(false);
      }
    }
    loadPrints();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedColor, delivery_id]);

  useEffect(() => {
    async function getInitialValues() {
      try {
        const response = await api.get(
          `/prints/${dictIdDelivery[delivery_id]}`
          // {
          //   params: {
          //     color:
          //       selectedColor.value !== 'none' ? selectedColor.value : null,
          //   },
          // }
        );
        const options = [];
        const control = [];

        response.data.forEach(print => {
          if (!control.includes(print.color)) {
            options.push({ label: print.color, value: print.color });
            control.push(print.color);
          }
        });

        // const style_collection = isSwimwear? "SWIMWEAR": "MAIN"
        // const colorOptions =  options.filter(o =>
        //   response.data.find(
        //     p =>
        //       p.color === o.value &&
        //       p.delivery_id === dictIdDelivery[delivery_id] &&
        //       (p.style_collection === style_collection)

        //   )
        // )
        // setColorOptions(
        //   colorOptions
        // );

        setColorOptions(
          options.filter(o =>
            response.data.find(
              p =>
                p.color === o.value &&
                p.delivery_id === dictIdDelivery[delivery_id]
            )
          )
        );
      } catch (err) {
        console.log(err);
      }
    }
    getInitialValues();
  }, [delivery_id]);

  useEffect(() => {
    async function loadProducts() {
      try {
        if (!selectedPrint) return;
        setLoading(true);
        const response = await api.get(
          `/products/${dictIdDelivery[delivery_id]}`,
          {
            params: {
              isSwimwear,
              print_name: selectedPrint && selectedPrint.name,
            },
          }
        );
        setProducts(response.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    loadProducts();
  }, [selectedPrint, delivery_id, isSwimwear]);

  const SelectPrintView = useCallback(
    () => (
      <div>
        <Typography
          align="center"
          style={{
            letterSpacing: '0.1em',
            fontSize: 27,
            color: 'black',
            marginBottom: 12,
          }}
        >
          {seasonName}
        </Typography>
        <Typography
          align="center"
          style={{ color: 'black', letterSpacing: '0.1em' }}
        />
        {/* MAINLY CONTAINER */}
        {/* <Grid
          // container
          // justifyContent'flex-end'
          // alignItems='flex-start'
          style={
            {
              // maxWidth: window.screenWidth,
              // backgroundColor: 'green',
            }
          }
        > */}
        {/* LEFT CONTAINER */}
        <LeftBar
          colorOptions={colorOptions}
          gridSize={gridSize}
          setGridSize={setGridSize}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
        />

        {/* RIGHT CONTAINER */}
        <Fade in timeout={300}>
          <Grid
            container
            // justifyContent'center'
            alignItems="flex-start"
            style={{
              marginTop: 71.5,
              width: screenWidth / 1.5,
              height: '100%',
              marginLeft: screenWidth / 3.5,
              // backgroundColor: 'blue',
            }}
          >
            {!loading &&
              prints.map(print =>
                !print ? null : (
                  <Grid
                    onClick={() => {
                      setSelectedPrint(print);
                      window.scrollTo(0, 0);
                    }}
                    key={String(print.name)}
                    style={{
                      position: 'relative',
                      cursor: 'pointer',
                    }}
                  >
                    <>
                      <Grid
                        style={{
                          bottom: 0,
                          height: '100%',
                          paddingTop: 20,
                          marginLeft: -15,
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                        className={classes.hover}
                      >
                        <Typography
                          // style={}
                          style={{
                            padding: '14px 12px',
                            backgroundColor: ' rgba(255, 255, 255, 0.95)',
                            color: 'black',
                            lineHeight: gridSizeValues.lineHeight,
                            width: gridSizeValues.width + 5,
                            fontSize: gridSizeValues.fontSize,
                            marginBottom: 5,
                          }}
                        >
                          {/* {' '} */}
                          {print.formattedName
                            .toUpperCase()
                            .replace('BAHIA GIRLS SCARF', 'ENCANTO SOLAR')}
                          {/* BURGUNDY ETHNIC BANANAS */}
                        </Typography>
                      </Grid>
                      <Img
                        src={
                          print.other_images[0] ||
                          'data:image/png;base64,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'
                        }
                        style={{
                          height: gridSizeValues.height,
                          width: gridSizeValues.width,
                          margin: '0px 2px 1px',
                          border: print.name === 'WHITE' && '1px solid #cccccc',
                        }}
                        alt="img"
                      />
                    </>
                  </Grid>
                )
              )}
          </Grid>
        </Fade>
        {/* </Grid> */}
      </div>
    ),
    [
      seasonName,
      colorOptions,
      gridSize,
      selectedColor,
      loading,
      prints,
      classes.hover,
      gridSizeValues.lineHeight,
      gridSizeValues.width,
      gridSizeValues.fontSize,
      gridSizeValues.height,
    ]
  );

  const PrintDetail = () => (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      style={{
        width: window.innerWidth,
        // background: 'blue',
      }}
    >
      {/* LEFT CONTAINER */}
      <LeftBarPrintDetail
        setProducts={setProducts}
        handlePrevPrint={handlePrevPrint}
        handleNextPrint={handleNextPrint}
        products={products}
        setSelectedPrint={setSelectedPrint}
        selectedPrint={selectedPrint}
      />

      {products.map((item, index) => (
        <Grid
          key={String(index)}
          style={{
            // background: 'green',
            zIndex: 1000,
            marginLeft: screenWidth * 0.45,
            // width: 447,
          }}
        >
          <Grid
            style={{
              zIndex: 3000,
              position: 'relative',
              right: screenWidth * -0.18,
              top: screenWidth * 0.09,
              cursor: 'pointer',
              overflow: 'hidden',
              backgroundColor: 'rgb(255,255,255,0.8)',
              // backgroundColor: 'blue',
              paddingLeft: 10,
              paddingRight: 20,
              width: 215,
            }}
          >
            <Typography style={{ fontSize: 14 }}>{item.style_code}</Typography>
            <Typography
              onClick={() => handleClickOpen(item)}
              variant="h5"
              style={{
                fontSize: 12,
                lineHeight: '24px',
                // width: 200,
              }}
            >
              {item.description.replace(selectedPrint.name, '')}
            </Typography>
            <Grid
              container
              // justifyContent'center'
              alignItems="center"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                handleAddFavorite(item);
              }}
            >
              <Typography
                variant="body2"
                style={{ color: '#000000', marginRight: 4 }}
              >
                {item.isFavorite ? 'Added' : 'Add'} to{' '}
                {selectedUser
                  ? `${selectedUser?.name.split(' ')[0]}'s collection`
                  : 'collection'}
              </Typography>
              {item.isFavorite ? (
                <AiFillHeart
                  style={{
                    color: '#000000',
                    fontSize: 14,
                  }}
                />
              ) : (
                <AiOutlineHeart
                  style={{
                    color: '#000000',
                    fontSize: 14,
                  }}
                />
              )}
            </Grid>
            <Grid
              container
              alignItems="center"
              onClick={() => handleClickOpen(item)}
            >
              <Typography
                style={{
                  color: '#000000',
                  fontSize: 14,
                  marginRight: 6,
                }}
              >
                Details
              </Typography>
              <AddIcon
                style={{
                  color: '#000000',
                  fontSize: 18,
                  // marginTop: 2.5,
                  // marginBottom: 3,
                }}
              />
            </Grid>
          </Grid>
          <Grid
            style={{ display: 'inline-block', position: 'relative' }}
            onClick={() => handleClickOpen(item)}
          >
            {item.status === 'Sold Out' && (
              <Typography
                align="center"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#fff',
                  zIndex: 1000,
                  fontSize: 60,
                  letterSpacing: '0.1em',
                  lineHeight: '40px',
                  width: 447,
                }}
              >
                SOLD OUT{' '}
              </Typography>
            )}
            <img
              src={
                item.mainly_image ||
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAPFBMVEXu7u62trbx8fHPz8/t7e2zs7O8vLy5ubnl5eWrq6vc3Nzq6urZ2dnh4eHV1dW6urrHx8fBwcHKysqlpaXy5cTEAAAEF0lEQVR4nO3bjXKkKBQFYLj8CAIK5v3fdS/Y9mi3md1UZavFOt9UTTpgujwBQaEjBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDH6N2nT+l3TfaNulNEGo18Y+KnT+sXUXkPKGW5USOGs4BShk+f1++JJ52Uu+l0m0akfN6GN+im66RA7jygNK7veYNcnBo1fJNQDmo9IrouQ2az+S4gt+ImdzjqlLMp0Pz5/6XGfvp8f4qm9xhmVimwNNmTys4GVv0+x5uStiGFKO1a+NGktq+EQtjXgGo3ZOpdG5tlaiPR0HvC+BJgu1U1C7eo6T+heQQkEYJ4vHzc6PD1F/pPaHI7fXKZi+2yzn60tLrBhdx/Qqlbmdpmi6WlCcN+pOk7YXvYpeU5fj4iqv2k0XVC48TLU/B6XYbbJGz3K/rQqi0PDXdJ2MYZd7iPMXW0OTxV9ZzQ1MuQjk/BrZvS/kLsOmEdV15uVNttKKm7tGEbOceTNlxuknBdrTiuRpn6PHi4Pe864VAnfMr7RmyhSd4loRlfG7HNkCLdZj5cb0t3U/464R+X4LpOKE1qiRw/2/M/Y9db7yTvk1DOayEllbNKdHZI5wkfj09itzx6HHm6T8gR9SEB6ZeA3SeUxnLn1FttuyRvlrA247aIz8/678uJN0hYB9FlinFa7NmacG8Jz/dE12X885re1kvP1rz/qrc17/pI/6OIZtb//p4XE6z5gdLh3hPfwEzqP5pSb1304eRTQt/49JkCAAAAAEBftHt/0D0rq9zFHhmfH1n7U0LHkrY749uC/lnZ/r3aMet+zjXoGEaVRN18UfG58hvVWBdGp6kGiDoqRy76aWxV9S8RjmXCRdLCjfwjiotDNOo6f66g/TBYHwUVX8y6cSaCNPwdTd5yDWkvZ+vHcfBz4apZSSv2ZbWfpi/H71Bo9Hnx0Q1+3Xe8BG0yUbGkfOCv87pzZohCCF+RKPog/EJkCyd1RLnwU70f92X1XWjO/DoJ7p2csvXSy3RTXU9GzWTr/svo2wb29gGM+pqb1yc+whJfc1w1lFI43q6s4t+EiIac59rC7Xmp69AkUROW0hK2Pe0tIX9DX9xe9YgtYR6Z25e1d+HIVnHCWKv1JROO3PXCY8NX8XmnxD1R6MwxazJOo/2oSZlAgct3Ze2CIyVr+8vMv5lIwkx0neuwtYbkPueNL4+yzK8XSsZ749r1RYvlq9Rz3FqV9b5snfoCD008lBqu5mEre3+dGbG1Qe2PIYXnVNdek3CtD9Zz1aFO7+552KGsvY1v00b9kdrFt+IrOblhOfvyTRlN5v85rasYzdfrh8FvJox9/m3QD9w9HwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANzJP/MdJGqyWhqXAAAAAElFTkSuQmCC'
              }
              style={{
                cursor: 'pointer',
                height: 'auto',
                width: 447,
                margin: '0px 5px 10px',
                filter: item.status === 'Sold Out' && 'brightness(65%)',
              }}
              alt="img"
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
    //   </Fade>
    // </Grid>
  );

  if (selectedPrint) {
    return (
      <>
        {selectedProduct && (
          <ModalProduct
            products={products}
            setProducts={setProducts}
            handlePrevProduct={handlePrevProduct}
            handleNextProduct={handleNextProduct}
            open={open}
            handleClose={handleClose}
            product={selectedProduct}
          />
        )}
        <PrintDetail />
      </>
    );
  }
  return <SelectPrintView />;
}

const wrapperComponent = withStyles(styles)(PrintView);

export default wrapperComponent;
